__turbopack_context__.v({
  "container": "NavbarOrderFormatFilter-module-scss-module__b4lhAq__container",
  "navBar": "NavbarOrderFormatFilter-module-scss-module__b4lhAq__navBar",
  "orderFormatData": "NavbarOrderFormatFilter-module-scss-module__b4lhAq__orderFormatData",
  "orderTypeIcon": "NavbarOrderFormatFilter-module-scss-module__b4lhAq__orderTypeIcon",
  "whiteLabeled": "NavbarOrderFormatFilter-module-scss-module__b4lhAq__whiteLabeled",
});
